import axios from 'axios'
import {EXCLUIR_PRESTADOR} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function excluirVeiculo (idPRestador, idEmpresa) {
  const url = `${URL}/prestador/${idPRestador}/empresa/${idEmpresa}/excluir`;

  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_PRESTADOR,
        payload: response
      })
  );
}
